// removed by extract-text-webpack-plugin
module.exports = {"list-view":"_1fN2gZinmKUK2SAYY-IQlj","empty":"_1sT1zR6Kuaz8oyuqpBfJhi","list-item":"_2mUqQWJ8NWaE0MFuf6Ioxb","spin":"wQA8rrvq-tKldOumZ02T6"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/List/styles.scss
// module id = 258
// module chunks = 18